import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, Task } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  sendActivityReport(
    request: Boundaries["sendActivityReport"]["request"],
  ): void;
}

function useSendActivityReport(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(selector.isSendActivityReportRequestPending),
    isRequestSuccess: useSelector(selector.isSendActivityReportRequestSuccess),
    isRequestFailure: useSelector(selector.isSendActivityReportRequestFailure),
    sendActivityReport: core.sendActivityReport,
  };
}

export { useSendActivityReport };
